import http from '../../http-common'

class SportsmanService {

  getSportsmanList(filterValue) {
    return http.post('/sportsman/list', filterValue)
    .catch((error) => {
      console.log(error.message)
      throw error
    })
  }

  getSportsmanOptions(filterValue) {
    return http.post('/sportsman/options', filterValue)
    .catch((error) => {
      console.log(error.message)
      throw error
    })
  }

  getSportsmanTrainers(fedId) {
    return http.get('/sportsman/trainers/' + fedId)
    .catch((error) => {
      console.log(error.message)
      throw error
    })
  }

  getSportsman(id) {
    return http.get('/sportsman/' + id)
    .catch((error) => {
      console.log(error.message)
      throw error
    })
  }

  saveSportsman(rec) {
    return http.post('/sportsman', rec)
    .catch((error) => {
      console.log(error.message)
      throw e
    })
  }

  deleteSportsman(id) {
    return http.delete('/sportsman/' + id)
    .catch((error) => {
      console.log(error.message)
      throw e
    })
  }

}

export default new SportsmanService()
